import { type NewPaymentMethodDialogViewModel } from '@/features/billing/payment-methods/NewPaymentMethodDialog/NewPaymentMethodDialogViewModel'
import { NewPaymentMethodDialog } from '@/features/billing/payment-methods/NewPaymentMethodDialog'
import { CardPaymentMethodEditorContentContainer } from '@/features/billing/payment-methods/NewPaymentMethodDialog/CardPaymentMethodEditorContent/CardPaymentMethodEditorContentContainer'
import { ContentError } from '@/components/ContentError'
import { ContentLoading } from '@/components/ContentLoading'
import { ModalSheetContentBlock } from '@/components/ModalSheet'
import { useActivation } from '@/hooks/view-model-hooks'
import { observer } from 'mobx-react-lite'

export interface NewPaymentMethodDialogContainerProps {
  vm: NewPaymentMethodDialogViewModel
}

export const NewPaymentMethodDialogContainer = observer(
  function NewPaymentMethodDialogContainer({
    vm,
  }: NewPaymentMethodDialogContainerProps) {
    const editorVm = vm.editorVm
    useActivation(editorVm ?? undefined)
    if (!editorVm) {
      return null
    }

    return (
      <NewPaymentMethodDialog
        showing={vm.modal.showing}
        isDisabled={editorVm.save.pending || editorVm.prepare.pending}
        onClose={vm.modal.close}
        isSavePending={editorVm.save.pending}
        onSave={editorVm.save}
        saveError={editorVm.save.error}
        onDismissSaveError={editorVm.save.reset}
      >
        {editorVm.prepare.match({
          pending: () => <ContentLoading />,
          rejected: (err) => (
            <ModalSheetContentBlock>
              <ContentError error={err} />
            </ModalSheetContentBlock>
          ),
          resolved: () => (
            <CardPaymentMethodEditorContentContainer vm={editorVm} />
          ),
        })}
      </NewPaymentMethodDialog>
    )
  },
)
